import { createSlice } from "@reduxjs/toolkit";
import {
  getAllInstrumentGroups,
  getClientList,
  getClosedTrades,
  getDeals,
  getEquityReport,
  getMoneyTransferReport,
  getOpenPositions,
  getSubIbList,
  getTopClientReport,
  getOfficesInfo,
  getLoginInfo,
  getSymbolInfo,
} from "./thunk";

export const initialState = {
  // Get Client List
  clientList: [],
  isListSuccess: false,
  clientListLoading: false,
  // Get Closed Trades
  closedPositions: [],
  isListClosedPositionsSuccess: false,
  closedPositionsLoading: false,
  // Get Deals
  dealsData: [],
  isListDealsSuccess: false,
  dealsLoading: false,
  // Get Equity Report
  equityReports: [],
  isListEquityReportsSuccess: false,
  getEquityReportLoading: false,
  // Get Money Transfer Report
  moneyTransfers: [],
  isListMoneyTransfersSuccess: false,
  getMoneyTransferReportLoading: false,
  // Get Open Positions
  openPositions: [],
  isOpenPositionsSuccess: false,
  getOpenPositionsLoading: false,
  // Get SubIb List
  subIbList: [],
  isListSubIbListSuccess: false,
  getSubIbListLoading: false,
  // Get Top Client Report
  topClients: [],
  isListTopClientsSuccess: false,
  getTopClientReportLoading: false,
  // Get All Instrument Groups
  allInstrumentGroups: [],
  getAllInstrumentGroupsSuccess: {},
  // Get Offices Info
  getOfficesInfoData: [],
  getOfficesInfoError: {},
  // Error Handling
  error: {},
};

const ReportSlice = createSlice({
  name: "ReportSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get Client List
    builder.addCase(getClientList.pending, (state) => {
      state.clientListLoading = true;
      state.error = false;
    });
    builder.addCase(getClientList.fulfilled, (state: any, action: any) => {
      state.clientList = action.payload;
      state.isListSuccess = true;
      state.clientListLoading = false;
      state.error = false;
    });
    builder.addCase(getClientList.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
      state.clientListLoading = false;
    });
    // Get Closed Trades
    builder.addCase(getClosedTrades.pending, (state) => {
      state.closedPositionsLoading = true;
      state.error = false;
    });
    builder.addCase(getClosedTrades.fulfilled, (state: any, action: any) => {
      state.closedPositions = action.payload;
      state.isListClosedPositionsSuccess = true;
      state.closedPositionsLoading = false;
      state.error = false;
    });
    builder.addCase(getClosedTrades.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
      state.closedPositionsLoading = false;
    });
    // Get Deals
    builder.addCase(getDeals.pending, (state) => {
      state.dealsLoading = true;
      state.error = false;
    });
    builder.addCase(getDeals.fulfilled, (state: any, action: any) => {
      state.dealsData = action.payload;
      state.isListDealsSuccess = true;
      state.dealsLoading = false;
      state.error = false;
    });
    builder.addCase(getDeals.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
      state.dealsLoading = false;
    });
    // Get Equity Report
    builder.addCase(getEquityReport.pending, (state) => {
      state.getEquityReportLoading = true;
      state.error = false;
    });
    builder.addCase(getEquityReport.fulfilled, (state: any, action: any) => {
      state.equityReports = action.payload;
      state.isListEquityReportsSuccess = true;
      state.getEquityReportLoading = false;
      state.error = false;
    });
    builder.addCase(getEquityReport.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
      state.getEquityReportLoading = false;
    });
    // Get Money Transfer Report
    builder.addCase(getMoneyTransferReport.pending, (state) => {
      state.getMoneyTransferReportLoading = true;
      state.error = false;
    });
    builder.addCase(
      getMoneyTransferReport.fulfilled,
      (state: any, action: any) => {
        state.moneyTransfers = action.payload;
        state.isListMoneyTransfersSuccess = true;
        state.getMoneyTransferReportLoading = false;
        state.error = false;
      }
    );
    builder.addCase(
      getMoneyTransferReport.rejected,
      (state: any, action: any) => {
        state.error = action.payload || null;
        state.getMoneyTransferReportLoading = false;
      }
    );
    // Get Open Positions
    builder.addCase(getOpenPositions.pending, (state) => {
      state.getOpenPositionsLoading = true;
      state.error = false;
    });
    builder.addCase(getOpenPositions.fulfilled, (state: any, action: any) => {
      state.openPositions = action.payload;
      state.isOpenPositionsSuccess = true;
      state.getOpenPositionsLoading = false;
      state.error = false;
    });
    builder.addCase(getOpenPositions.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
      state.isOpenPositionsSuccess = false;
      state.getOpenPositionsLoading = false;
    });
    // Get SubIb List
    builder.addCase(getSubIbList.pending, (state) => {
      state.getSubIbListLoading = true;
      state.error = false;
    });
    builder.addCase(getSubIbList.fulfilled, (state: any, action: any) => {
      state.subIbList = action.payload;
      state.isListSubIbListSuccess = true;
      state.getSubIbListLoading = false;
      state.error = false;
    });
    builder.addCase(getSubIbList.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
      state.getSubIbListLoading = false;
    });
    // Get Top Client Report
    builder.addCase(getTopClientReport.pending, (state) => {
      state.getTopClientReportLoading = true;
      state.error = false;
    });
    builder.addCase(getTopClientReport.fulfilled, (state: any, action: any) => {
      state.topClients = action.payload;
      state.isListTopClientsSuccess = true;
      state.getTopClientReportLoading = false;
      state.error = false;
    });
    builder.addCase(getTopClientReport.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
      state.getTopClientReportLoading = false;
    });
    // Get All Instrument Groups
    builder.addCase(
      getAllInstrumentGroups.fulfilled,
      (state: any, action: any) => {
        state.allInstrumentGroups = action.payload;
        state.getAllInstrumentGroupsSuccess = true;
      }
    );
    builder.addCase(
      getAllInstrumentGroups.rejected,
      (state: any, action: any) => {
        state.allInstrumentGroups = action.error.message;
      }
    );
    // Get Offices Info
    builder.addCase(getOfficesInfo.fulfilled, (state: any, action: any) => {
      state.getOfficesInfoData = action.payload;
    });
    builder.addCase(getOfficesInfo.rejected, (state: any, action: any) => {
      state.getOfficesInfoError = action.error.message;
    });
    // Get Login Info
    builder.addCase(getLoginInfo.fulfilled, (state: any, action: any) => {
      state.getLoginInfo = action.payload;
    });
    builder.addCase(getLoginInfo.rejected, (state: any, action: any) => {
      state.getLoginInfoError = action.error.message;
    });
    // Get Symbol Info
    builder.addCase(getSymbolInfo.fulfilled, (state: any, action: any) => {
      state.getSymbolInfo = action.payload;
    });
    builder.addCase(getSymbolInfo.rejected, (state: any, action: any) => {
      state.getSymbolInfoError = action.error.message;
    });
  },
});

export default ReportSlice.reducer;
